import { render } from "./ContactListSort.vue?vue&type=template&id=11a430d2&ts=true"
import script from "./ContactListSort.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactListSort.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/contact/components/ContactListSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11a430d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11a430d2', __exports__)) {
    api.reload('11a430d2', __exports__)
  }
  
  module.hot.accept("./ContactListSort.vue?vue&type=template&id=11a430d2&ts=true", () => {
    api.rerender('11a430d2', render)
  })

}


export default __exports__